import React from 'react'
import { Divider, Typography } from '@mui/material'

import Tabs, { TabObjects } from 'components/Common/Tabs'

import { colors, FONT_WEIGHT } from 'styles/theme'

import {
  StyledContainer,
  StyledContent,
  StyledSubTitleContainer,
  StyledTitleContainer,
} from './style'

type TitleProps = {
  /**
   * If `true` the divider at the end will not appear
   */
  disableDivider?: boolean
  /**
   * Subtitle which is below the title
   */
  subtitle?: string
  /**
   * Icon which is before the subtitle
   */
  icon?: React.ReactNode
  /**
   * Optional tabs menu that goes on the right side of the title
   */
  tabs?: TabObjects[]
  /**
   * The title of the content
   */
  title: string
  /**
   * value of tabs
   */
  tabValue?: number | string | boolean
  /**
   * Function to change tabs
   */
  handleTabChange?: (value: number | string) => void
  containerSx?: React.CSSProperties
}

const Title: React.FC<TitleProps> = ({
  subtitle,
  icon,
  tabs,
  title,
  tabValue,
  handleTabChange,
  disableDivider = false,
  containerSx,
}) => {
  return (
    <StyledContainer sx={containerSx}>
      <StyledContent>
        <StyledTitleContainer style={{ width: tabs ? '50%' : '100%' }}>
          <Typography variant="h3">{title}</Typography>
          <StyledSubTitleContainer>
            {icon}
            <Typography
              color={colors.gray}
              fontWeight={FONT_WEIGHT.REGULAR}
              variant="body1"
            >
              {subtitle}
            </Typography>
          </StyledSubTitleContainer>
        </StyledTitleContainer>
        {tabs && tabValue !== undefined && handleTabChange ? (
          <Tabs value={tabValue} onChange={handleTabChange} tabs={tabs} />
        ) : null}
      </StyledContent>
      {!disableDivider ? (
        <Divider
          sx={{
            display: 'flex',
            flexDirection: 'row',
            borderColor: colors.gray,
          }}
        />
      ) : null}
    </StyledContainer>
  )
}

export default Title
